// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 89 ? "component---src-templates-page-js" : chunkId) + "-" + {"89":"0d05a9f8ba8be7c1f6c5","172":"5ebec74b41c01aace926","577":"cac0a91d031c9d63e1b0"}[chunkId] + ".js";
};